export class UserTagsService {
  tags: string[];

  constructor(tags: string) {
    this.tags = tags.split(",") || [];
  }

  sort() {
    this.tags = this.tags.sort((a, b) => {
      return +a.split("_")[1] - +b.split("_")[1];
    });
    return this;
  }

  spliteDate() {
    this.tags = this.tags.map((t) => {
      const splited = t.split("_").length > 1;
      if (splited) {
        return t;
      } else {
        const d = Date.now();
        return `${t}_${d}`;
      }
    });
    return this;
  }

  cutDates() {
    this.tags = this.tags.map((tag) => tag.split("_")[0]);
    return this;
  }

  getFirstTag() {
    if (!this.tags || !this.tags.length) return undefined;
    return this.sort().tags[0];
  }
}
export function drawTagWithoutDates(tag: string) {
  return tag.split("_")[0];
}
